import { Ad } from "../../../types/adType";

/**
 * Interleaves premium ads into a regular ad feed using a clean 2:4 injection pattern.
 * No random shuffling — both arrays are consumed in the order they are received
 * (pass them pre-sorted, e.g. chronologically by published_at descending).
 *
 * Pattern: [reg, reg, reg, reg, prem, prem, reg, reg, reg, reg, prem, prem, ...]
 * When premium ads run out, remaining regular ads are appended as-is.
 * When regular ads run out, remaining premium ads are appended as-is.
 */
const interleaveAds = (premiumAds: Ad[], regularAds: Ad[]): Ad[] => {
    const result: Ad[] = [];
    let pi = 0; // premium index
    let ri = 0; // regular index

    while (ri < regularAds.length || pi < premiumAds.length) {
        // Take up to 4 regular ads
        for (let i = 0; i < 4 && ri < regularAds.length; i++) {
            result.push(regularAds[ri++]);
        }
        // Inject up to 2 premium ads
        for (let i = 0; i < 2 && pi < premiumAds.length; i++) {
            result.push(premiumAds[pi++]);
        }
    }

    return result;
};

export default interleaveAds;